import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preview"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black opacity-25" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none" }
const _hoisted_4 = { class: "relative my-6 mx-auto w-auto max-w-sm" }
const _hoisted_5 = { class: "relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "border-blueGray-200 flex items-start justify-between rounded-t border-b border-solid p-5" }, " 写真をバスに送ります ", -1)
const _hoisted_7 = { ref: "photoPreview" }
const _hoisted_8 = { class: "border-blueGray-200 flex items-center justify-end rounded-b border-t border-solid p-6" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", null, [
                _createElementVNode("img", _hoisted_7, null, 512)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "mx-5 w-28 rounded-md border border-solid bg-blue-400 px-6 py-3 text-white",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal()))
                }, " やめる "),
                _createElementVNode("button", {
                  class: "mx-5 w-28 rounded-md bg-blue-400 px-6 py-3 text-white",
                  type: "button",
                  disabled: _ctx.isUploadButtonEnabled,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpload()))
                }, _toDisplayString(_ctx.isUploadButtonEnabled ? "送信中..." : "送る"), 9, _hoisted_9)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}